import { render, staticRenderFns } from "./xp-login.vue?vue&type=template&id=3ea86c86&"
import script from "./xp-login.vue?vue&type=script&lang=js&"
export * from "./xp-login.vue?vue&type=script&lang=js&"
import style0 from "./xp-login.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports